import type { TemplateType } from "@/components/offer/offerDocumentTypes";

export type OfferDocumentModeOption = {
  value: TemplateType;
  icon: "bolt" | "file-text" | "star";
  title: string;
  description: string;
  sections: string[];
  excludedSections?: string[];
  footer: string;
  usageHint: string;
};

export const OFFER_DOCUMENT_MODE_OPTIONS: OfferDocumentModeOption[] = [
  {
    value: "quick",
    icon: "bolt",
    title: "Decyzyjna",
    description: "Klient pyta o cenę. Szybka wycena po oględzinach.",
    sections: [
      "Cena całkowita (bez rozbicia na pozycje)",
      "Lista prac bez ilości i jednostek",
      "Materiały i gwarancja",
    ],
    excludedSections: ["Kosztorys, harmonogram, wyłączenia"],
    footer: "Szybka decyzja cenowa",
    usageHint: "Malowanie, drobne naprawy, stały klient, klient pyta tylko o cenę",
  },
  {
    value: "explained",
    icon: "file-text",
    title: "Przekonująca",
    description: "Klient chce wiedzieć za co płaci. Zakres wymaga uzasadnienia.",
    sections: [
      "Pełny kosztorys (pozycja / ilość / cena)",
      "Założenia i wyłączenia",
      "Harmonogram",
      "Przycisk akceptacji dla klienta",
    ],
    footer: "Pełne uzasadnienie zakresu",
    usageHint:
      'Glazura, tynki, łazienka - klient pyta "czemu tyle kosztuje", nowa znajomość',
  },
  {
    value: "premium",
    icon: "star",
    title: "Reprezentacyjna",
    description: "Duże zlecenie. Wygrywasz profesjonalizmem i zaufaniem.",
    sections: [
      "Okładka z danymi projektu",
      "Streszczenie projektu",
      "Harmonogram przed kosztorysem",
      "Pełny kosztorys",
      "Przycisk akceptacji dla klienta",
    ],
    footer: "Profesjonalna prezentacja",
    usageHint:
      "Remont pod klucz, duży budżet, klient premium, pierwsza duża robota z nowym inwestorem",
  },
];

export function getOfferDocumentModeOption(value: TemplateType): OfferDocumentModeOption {
  return (
    OFFER_DOCUMENT_MODE_OPTIONS.find((o) => o.value === value) ?? OFFER_DOCUMENT_MODE_OPTIONS[0]
  );
}
